// paleta fixa: roda por cima dos dois temas e também deslogado
const cores = {
  fundo: "#0B1226",
  circulo: "#14244C",
  destaque: "#7EA9E8",
  ponto: "#5B8FD9",
  titulo: "#FFFFFF",
  texto: "#9DAFC9",
  rodape: "#64789C",
  botaoFundo: "#AFD6F2",
  botaoFundoHover: "#C9E4F9",
  botaoTexto: "#0B1226",
};

const styles = () => ({
  container: {
    position: "fixed",
    inset: 0,
    zIndex: 1400,
    backgroundColor: cores.fundo,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  circulo: {
    position: "absolute",
    top: "50%",
    right: { xs: "-45%", md: "-8%" },
    transform: "translateY(-50%)",
    width: { xs: "120vw", md: "72vw" },
    maxWidth: "1100px",
    aspectRatio: "1 / 1",
    borderRadius: "50%",
    backgroundColor: cores.circulo,
    pointerEvents: "none",
  },
  conteudo: {
    position: "relative",
    zIndex: 1,
    width: "100%",
    maxWidth: "1400px",
    height: "100%",
    display: "flex",
    flexDirection: { xs: "column-reverse", md: "row" },
    alignItems: "center",
    justifyContent: "center",
    gap: { xs: 4, md: 2 },
    px: { xs: 3, sm: 5, md: 8 },
    py: { xs: 5, md: 0 },
    overflowY: "auto",
  },
  coluna: {
    flex: 1,
    minWidth: 0,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  etiqueta: {
    display: "flex",
    alignItems: "center",
    gap: 1.25,
    mb: 2.5,
  },
  ponto: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: cores.ponto,
    flexShrink: 0,
    "@keyframes systemBlockPontoPisca": {
      "0%, 100%": { opacity: 1 },
      "50%": { opacity: 0.2 },
    },
    animation: "systemBlockPontoPisca 1.4s ease-in-out infinite",
  },
  etiquetaTexto: {
    fontFamily: "monospace",
    fontSize: { xs: "0.7rem", md: "0.78rem" },
    lineHeight: 1,
    letterSpacing: "0.18em",
    textTransform: "uppercase",
    color: cores.destaque,
  },
  titulo: {
    color: cores.titulo,
    fontWeight: 700,
    fontSize: { xs: "2.25rem", sm: "3rem", md: "3.75rem" },
    lineHeight: 1.05,
    letterSpacing: "-0.02em",
    maxWidth: "12ch",
    mb: 3,
  },
  descricao: {
    color: cores.texto,
    fontSize: { xs: "1rem", md: "1.0625rem" },
    lineHeight: 1.6,
    maxWidth: "34ch",
    mb: 4,
  },
  botao: {
    backgroundColor: cores.botaoFundo,
    color: cores.botaoTexto,
    fontWeight: 700,
    textTransform: "none",
    fontSize: "1rem",
    borderRadius: "999px",
    px: 4,
    py: 1.5,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: cores.botaoFundoHover,
      boxShadow: "none",
    },
  },
  rodape: {
    mt: 3,
    fontFamily: "monospace",
    fontSize: { xs: "0.7rem", md: "0.75rem" },
    color: cores.rodape,
    wordBreak: "break-word",
  },
  colunaImagem: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  imagem: {
    width: "100%",
    maxWidth: { xs: "240px", sm: "320px", md: "560px" },
    height: "auto",
    display: "block",
    userSelect: "none",
  },
});

export default styles;
